import Vue from 'vue';

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import Toasted from 'vue-toasted';
Vue.use(Toasted)

Vue.component('form-contact', require('../pages/contact/Contact.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if (document.getElementById("form-contact")) {
    new Vue({
        el: '#form-contact',
    });
}